import BasePage from "./BasePage";

export default class ManagePage extends BasePage {

    public static async init() {
        await super.init();

        $("#Confirm").on("click", function () {
            (<any>window).App.instances.vm.$store.dispatch("testRideStore/confirmRegistration", {
                registrationToken: $("#RegistrationToken").val(),
                email: $("#Email").val()
            }).then(function (response) {
                if (response.data) {
                    window.location.href = window.location.href;
                }
            });
        });

        $("#Cancel").on("click", function () {
            (<any>window).App.instances.vm.$store.dispatch("testRideStore/cancelRegistration", {
                registrationToken: $("#RegistrationToken").val(),
                email: $("#Email").val()
            }).then(function (response) {
                if (response.data) {
                    window.location.href = window.location.href;
                }
            });
        });
    }
}